import { Button, Icon, Modal, Stack, Text } from "@fidelix/fx-miranda";
import { Trans } from "@lingui/react/macro";
import styled from "styled-components";
import { Heading } from "react-aria-components";
import { Alarm } from "../alarm.model";
import { useUpdateAlarmMutation } from "../alarm.mutations";
import { queryClient } from "../../utils/query-client";

export function AcknowledgeAlarmModal({
  alarm,
  onClose,
}: {
  onClose: () => void;
  alarm: Alarm;
}) {
  const { mutateAsync, isError, isPending } = useUpdateAlarmMutation();

  const onAcknowledgeAlarm = async () => {
    // Using value! here since we know here that value exists
    await mutateAsync(
      { ...alarm, value: { ...alarm.value!, alarmState: 0 } },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: ["point-details-one-time"],
          });
          onClose();
        },
      },
    );
  };
  return (
    <Modal
      onClose={onClose}
      placement="middle"
      data-test-id="acknowledge-alarm-modal"
    >
      <ModalWrapper>
        <ModalHeading slot="title">
          <Icon icon="attentionFilled" size={64} color="primary" />
          <Text variant="title2Bold">
            <Trans>Are you sure?</Trans>
          </Text>
        </ModalHeading>
        <Modal.Body aria-label="acknowledge-alarm-modal">
          <Text variant="body">
            <Trans>
              The alarm will be marked as acknowledged. You cannot undo this
              action later.
            </Trans>
          </Text>
        </Modal.Body>
      </ModalWrapper>

      <ModalFooter>
        {isError && (
          <Text color="error" variant="bodyLight">
            <Trans>Submitting failed</Trans>
          </Text>
        )}
        <Stack spacing="normal" justify="center">
          <Button variant="secondary" onPress={onClose}>
            <Trans>Cancel</Trans>
          </Button>
          <Button
            isLoading={isPending}
            iconPlacement="left"
            isDisabled={isPending}
            onPress={onAcknowledgeAlarm}
          >
            <Trans>Submit</Trans>
          </Button>
        </Stack>
      </ModalFooter>
    </Modal>
  );
}

const ModalFooter = styled(Modal.Footer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(p) => p.theme.space("small")};
`;
const ModalHeading = styled(Heading)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(p) => p.theme.space("small")};
`;

const ModalWrapper = styled.div`
  display: flex;
  gap: ${(p) => p.theme.space("medium")};
  flex-direction: column;
  justify-content: center;
  width: 500px;
  height: 300px;
  text-align: center;
`;
